import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import PropTypes from 'prop-types';
/**
 * Internal dependencies
 */

import Rating from './index';
/**
 * Display a set of stars representing the review's rating.
 *
 * @return { object } -
 */

var ReviewRating = function ReviewRating(_ref) {
  var review = _ref.review,
      props = _objectWithoutProperties(_ref, ["review"]);

  var rating = review && review.rating || 0;
  return createElement(Rating, _extends({
    rating: rating
  }, props));
};

ReviewRating.propTypes = {
  /**
   * A review object containing a `rating`.
   * See https://woocommerce.github.io/woocommerce-rest-api-docs/#retrieve-product-reviews.
   */
  review: PropTypes.object.isRequired
};
export default ReviewRating;
//# sourceMappingURL=review.js.map